import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import TermsOfUs from "./TermsOfUs"
import PrivacyPolicy from "./PrivacyPolicy"
import AccessibilityStatement from './AccessibilityStatement';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './Home';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>

  <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/TermsOfUs" element={<TermsOfUs/>} />
        <Route path="/termsofuse" element={<TermsOfUs/>} />
        <Route path="/privacyPolicy" element={<PrivacyPolicy/>} />
        <Route path="/accessibilityStatement" element={<AccessibilityStatement/>} />

      </Routes>

  </BrowserRouter>
);

